export const actionPlanDetailsSelector = state => state.actionPlanDetails;
